<template>
  <div class="animated fadeIn">
    <router-view @refresh="refresh()"></router-view>
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i>WSFinder Agent
      </template>

      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Installed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> last config updated_at
                <b-button size="sm" variant="info" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'updated_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'updated_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_mod">Isolation</label>
              <br>
              <select v-model="so.opt['setting']" @change="refresh">
                <option disabled value=''>Please select Mode</option>
                <option value='backup_mode":false'>Off</option>
                <option value='backup_mode":true'>On</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_osy_type">os</label>
              <br>
              <select v-model="so.opt['os_type']" @change="refresh">
                  <option disabled value=''>select Enable or Disable</option>
                  <option value="windows">Windows</option>
                  <option value="linux">Linux</option>
                </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_version">Version</label>
              <br>
              <v-select @click="refresh" @change="refresh" :disabled="build_list.length == 0" label="Build Version" v-model="so.opt['version']" :options="build_list"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_ip_addr">IP Address</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_ip_addr" v-model="so.opt['ip_addr']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_host">Host</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_host" v-model="so.opt['host']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_name">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['name']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <label for="ph_search_opt_type">Group Name</label>
            <b-button variant="primary" @click="chainGroup = true">Select Group</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <hr>
      <b-row>
        <b-col sm="2">
          <b-badge variant="primary">
            TOTAL : {{summaryData.enable + summaryData.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{summaryData.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{summaryData.disable}}
          </b-badge>
        </b-col>
        <b-col sm="10" class="md-12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="load"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='tag';so.skt='Tag';so.adv=false;so.sv=''">Tag</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='host';so.skt='Host';so.adv=false;so.sv=''">Host</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='ip_addr';so.skt='IP';so.adv=false;so.sv=''">IP</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="group" slot-scope="row">{{row.item.group && row.item.group.groupname || 'deleted group'}}</template>

        <template slot="is_del" slot-scope="row">
          <b-badge variant="success" v-if="!row.item.is_del">Enable</b-badge>
          <b-badge v-else variant="secondary">Disable</b-badge>
        </template>
        <template slot="setting" slot-scope="row">
          <b-badge variant="primary" v-if="row.item.setting.backup_mode">Enable</b-badge>
          <b-badge v-else variant="secondary">Disable</b-badge>
        </template>
        <template slot="os_type" slot-scope="row">{{ row.item.os_type }}</template>
        <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime}}</template>>
        <template slot="ip_addr" slot-scope="row">{{ `${row.item.host}@${row.item.ip_addr}` }}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <b-col class="md-8">
        <b-pagination size="sm" :total-rows="so.totalRows" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
      </b-col>
    </b-card>
    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
  </div>
</template>


<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import groupList from '../../Management/group/Group.List'

import agent from './service'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  target : "agent",
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})
export default {
  components: { DatePicker, vSelect, groupList },
  data: () => {
    return {
      build_list : [],
      chainGroup : false,
      codes,
      moment,
      group_name : '',
      custom,
      sync : { th : undefined, stop : false, interval : 15, enable : false },
      summaryData : { enable : 0, disable : 0 },
      //
      base_href : `${location.protocol}//${location.host}`,
      agents : [],
      show: true,
      so : default_opt(),
      th : undefined, // timer handler
    }
  },
  computed: {
    fields: function () {
      return [
      { key: 'id', label: '#' , thStyle: 'width: 5%'},
      { key: 'group', label: 'Group', thStyle: 'width: 15%'},
      { key: 'is_del', label: 'Status', thStyle: 'width: 15%'},
      { key: 'setting', label: 'IsLocation'},
      { key: 'ip_addr', label: 'HOST@IP'},
      { key: 'os_type', label: 'OS' , thStyle: 'width: 10%'},
      { key: 'created_at', label: 'Installed_at', thStyle: 'width: 15%'},
      { key: 'func', label: 'More' , thStyle: 'width: 10%'}
      ]
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['updated_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    reset() { this.so = default_opt(); this.group_name = undefined; this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems(ctx) {  return this.load(ctx); },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    async load(ctx = {}) {
      let so = {
        target : 'wsfinder.agent', cmd : 'list',
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : [{ name : 'is_del', value : false, op : '='}]  },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'os_type':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = parseInt(this.so.opt[k[i]]) > 0 ? this.set_op(k[i], this.so.opt[k[i]]) : this.set_op('', '')
              break;
            case 'mode':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }

      this.getVersion()

      return Api.Manager(so).then(rs => {
          this.so.totalRows = rs.total;
          return rs.body;
        }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    async getVersion() {
      let rs = await Api.Manager_Call('wsfinder.agent', 'version')
      this.build_list = rs.total > 0 ? rs.body : [];
    },
    async ping() {
      if(this.th) { clearTimeout(this.th); }
      if(this.agents &&  this.agents.length) {
        let mq_done = false;
        for (let i = 0; i < this.agents.length; i++) {
          let r = this.agents[i];
          if(!r.tag.startsWith("ws.")) {
            // ping to exchange
            if(mq_done) { continue; }
            else { agent.mq.Cmd("ping", '', this.exchange).then(rs => this.res(rs)); mq_done = true; }
          } else { agent.ws.Cmd("ping", `${r.id}`).then(rs => this.res(rs)); }
        }
        this.th = setTimeout(this.ping, 3000);
      }
    },
    res_ping(m) {
      if (m.pl.type != 'pong') { return; }
      _.forEach(this.agents, (agent, index) => {
        if (agent.tag == m.pl.tag) {
          let update = { ms : Math.abs(new Date().getTime() - Number(m.pl.content)), alive : true }
          this.agents[index] = _.assign(this.agents[index], update)
        }
      });
    },
    res_ping_ws(m) {
      if (m.cmd != 'pong') { return; }
      _.filter(this.agents, { id : m.agent_id }).forEach(a => {
        let update = { ms : Math.abs(new Date().getTime() - Number(m.body)), alive : true }
        this.agents[_.findIndex(this.agents, { id : m.agent_id })] = _.assign(a, update);
      });
    },
    res(m) {
      switch(m.ch) {
        case 'ws' : return this.res_ping_ws(m);
        case 'mq' : return this.res_ping(m);
      }
    },
    detail(item) { this.$router.push(`agent/${item.id}`); },
    hideList(e) {
      this.show = !e; console.log('agent.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    },
    summary() {
      let and = [];
      if(this.group) { and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      Api.Manager_Call('wsfinder.agent','summary', { and : and, or : [], sort : [] })
        .then(rs => { this.summaryData = Object.assign(this.summaryData, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  created() { console.log('agent.list.vue', 'created'); },
  destroyed() {
    console.log('agent.list.vue', 'destroyed');
    // this.signalr.off('wsfinder_response', this.res);
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
  },
  mounted() {
    console.log('agent.list.vue', 'mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(!this.view_detail !== false) {
      // not component
      this.summary()
    }
    // this.signalr.on('wsfinder_response', this.res)
  },
}
</script>
